import React, { createContext, useContext, useState, useEffect } from 'react'

// P0.26.1 (Sección G del encargo): el modo de vista Simple/Experto (`viewMode`/
// `toggleViewMode`) se retiró por completo -- P0.26 quitó el único toggle que lo
// controlaba (`MorePage.tsx`) y, auditado aquí, ningún otro componente real lo
// consumía salvo `SecondaryPickCard.tsx` (ver fix en ese archivo). Mantenerlo habría
// dejado a un cliente que hubiera guardado 'simple' en localStorage antes del deploy
// atrapado sin forma de volver a 'expert' -- justo la inconsistencia que "experiencia
// única de cliente" prohíbe. Solo sobrevive el manejo de favoritos, que sí se usa.

interface ViewSettingsContextType {
  favorites: string[]
  isFavorite: (id: string) => boolean
  toggleFavorite: (id: string) => void
}

const ViewSettingsContext = createContext<ViewSettingsContextType | undefined>(undefined)

export function ViewSettingsProvider({ children }: { children: React.ReactNode }) {
  const [favorites, setFavorites] = useState<string[]>(() => {
    try {
      const saved = localStorage.getItem('ja_favorites')
      return saved ? JSON.parse(saved) : []
    } catch {
      return []
    }
  })

  useEffect(() => {
    localStorage.setItem('ja_favorites', JSON.stringify(favorites))
  }, [favorites])

  const isFavorite = (id: string) => {
    return favorites.includes(id)
  }

  const toggleFavorite = (id: string) => {
    setFavorites((prev) => {
      if (prev.includes(id)) {
        return prev.filter((favId) => favId !== id)
      } else {
        return [...prev, id]
      }
    })
  }

  return (
    <ViewSettingsContext.Provider
      value={{
        favorites,
        isFavorite,
        toggleFavorite,
      }}
    >
      {children}
    </ViewSettingsContext.Provider>
  )
}

export function useViewSettings() {
  const context = useContext(ViewSettingsContext)
  if (context === undefined) {
    throw new Error('useViewSettings debe usarse dentro de un ViewSettingsProvider')
  }
  return context
}
